import type { TransactionWorkspaceProjectionV1 } from '@packproof/ux';
import type { PortalTransaction } from './api';

export function workspaceOf(item: PortalTransaction): TransactionWorkspaceProjectionV1 {
  return item.workspace;
}

export function revisionsOf(items: readonly PortalTransaction[]): Array<{ transactionId: string; factsRevision: number }> {
  return items.map((item) => ({
    transactionId: item.id,
    factsRevision: item.workspace.factsRevision,
  }));
}
